import moment from 'moment/moment';
import { FormattedMessage } from 'react-intl';
import {
  FIELD_TEXT_REQUIRED,
  JOB_FIELD_NAMES,
  MESSAGE_IDS as BASE_MESSAGE_IDS,
  ADDRESS_FIELDS,
  FIELD_SHOW_COMMON,
} from './constants.job';
import { FIELD_MEMBERS } from 'pages/AffordaWagesAndIncome/constants.fields';
import { validateNoSpecialChars } from 'utils/validateNoSpecialChars';

export const MESSAGE_IDS = {
  ...BASE_MESSAGE_IDS,
  title: 'afforda.wagesAndIncome.details.lastJob.title',
  description: 'afforda.wagesAndIncome.details.lastJob.subtitle',
};

export const FIELDS = ({
  intl,
  validateZip,
  disabledMembers,
  members,
  states,
}) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    {
      ...FIELD_TEXT_REQUIRED,
      ...FIELD_SHOW_COMMON,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.job.position" />
      ),
      name: JOB_FIELD_NAMES.position,
      rules: {
        required: true,
        validate: validateNoSpecialChars,
      },
      placeholder: intl?.formatMessage?.({
        id: 'afforda.wagesAndIncome.details.job.position',
      }),
    },
    {
      ...FIELD_SHOW_COMMON,
      variant: 'date',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.lastJob.dates.start" />
      ),
      name: JOB_FIELD_NAMES.startDate,
      placeholder: intl?.formatMessage?.({
        id: 'afforda.wagesAndIncome.details.job.start',
      }),
      disableFuture: true,
      defaultCalendarMonth: moment(moment().year(), 'YYYY'),
      rules: {
        maxDate: moment().startOf('day'),
        required: true,
      },
      GridProps: {
        xs: 6,
      },
    },
    {
      ...FIELD_SHOW_COMMON,
      variant: 'date',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.lastJob.dates.end" />
      ),
      name: JOB_FIELD_NAMES.endDate,
      placeholder: intl?.formatMessage?.({
        id: 'afforda.wagesAndIncome.details.job.end',
      }),
      disableFuture: true,
      defaultCalendarMonth: moment(moment().month(), 'mm'),
      watchFields: [JOB_FIELD_NAMES.startDate],
      rules: {
        minDate: moment().day(-90),
        maxDate: moment().startOf('day'),
        required: true,
      },
      GridProps: {
        xs: 6,
      },
      validate: (value) => {
        if (value && value.isBefore(moment())) {
          return intl?.formatMessage?.({
            id: 'afforda.wagesAndIncome.details.job.endBeforeToday',
          });
        }
      },
    },
    // Common - Company
    {
      ...FIELD_TEXT_REQUIRED,
      ...FIELD_SHOW_COMMON,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.job.company.name" />
      ),
      rules: {
        validate: validateNoSpecialChars,
      },
      placeholder: intl?.formatMessage?.({
        id: 'afforda.wagesAndIncome.details.job.company.name',
      }),
      name: JOB_FIELD_NAMES.employerName,
    },
    ...ADDRESS_FIELDS({ intl, states, validateZip }).map((field) => ({
      ...field,
      ...FIELD_SHOW_COMMON,
    })),
    //
    // Supervisor - No Self Employed
    //
    {
      ...FIELD_TEXT_REQUIRED,
      ...FIELD_SHOW_COMMON,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.job.supervisor.name" />
      ),
      name: JOB_FIELD_NAMES.supervisorName,
      placeholder: intl?.formatMessage?.({
        id: 'afforda.wagesAndIncome.details.job.supervisor.name',
      }),
      GridProps: {
        xs: 12,
      },
    },
    {
      ...FIELD_TEXT_REQUIRED,
      ...FIELD_SHOW_COMMON,
      variant: 'phone',
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.job.supervisor.phone" />
      ),
      name: JOB_FIELD_NAMES.supervisorPhone,
      placeholder: intl?.formatMessage?.({
        id: 'afforda.wagesAndIncome.details.job.supervisor.phone',
      }),
      GridProps: {
        xs: 12,
      },
    },
  ];
};

export const LAST_JOB_FIELD_NAMES = FIELDS({}).reduce((acc, field) => {
  acc[field.name] = field.name;
  return acc;
}, {});
